// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__yBPmX","Cell":"EmployeeTable_Cell__+Klme","Paper":"EmployeeTable_Paper__DjA5G"};